var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "container-max",
      class: { "p-0": _vm.$ceres.isShopBuilder },
    },
    [
      _c(
        "div",
        { staticClass: "position-relative" },
        [
          _c(
            "div",
            { staticClass: "d-flex flex-grow-1 position-relative my-2" },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.searchString,
                    expression: "searchString",
                  },
                ],
                ref: "searchInput",
                staticClass: "search-input flex-grow-1 px-3 py-2",
                attrs: {
                  type: "search",
                  autofocus: "",
                  placeholder: _vm.$translate(
                    "Ceres::Template.headerSearchPlaceholder"
                  ),
                  "aria-label": _vm.$translate(
                    "Ceres::Template.headerSearchTerm"
                  ),
                },
                domProps: { value: _vm.searchString },
                on: {
                  input: [
                    function ($event) {
                      if ($event.target.composing) return
                      _vm.searchString = $event.target.value
                    },
                    function ($event) {
                      return _vm.onValueChanged($event.target.value)
                    },
                  ],
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    )
                      return null
                    return _vm.search()
                  },
                  focus: function ($event) {
                    _vm.isSearchFocused = true
                  },
                  blur: function ($event) {
                    return _vm.onBlurSearchField($event)
                  },
                },
              }),
              _vm._v(" "),
              _vm._t("search-button", function () {
                return [
                  _c(
                    "button",
                    {
                      staticClass: "search-submit px-3",
                      attrs: {
                        type: "submit",
                        "aria-label": _vm.$translate(
                          "Ceres::Template.headerSearch"
                        ),
                      },
                      on: {
                        click: function ($event) {
                          return _vm.search()
                        },
                      },
                    },
                    [
                      _c("icon", {
                        staticClass: "fa-fw",
                        attrs: {
                          icon: "search",
                          loading: _vm.autocompleteIsLoading,
                        },
                      }),
                    ],
                    1
                  ),
                ]
              }),
            ],
            2
          ),
          _vm._v(" "),
          [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      (_vm.searchString.length >= _vm.searchMinLength &&
                        _vm.hasInitialInput) ||
                      _vm.$ceres.isShopBuilder,
                    expression:
                      "(searchString.length >= searchMinLength && hasInitialInput) || $ceres.isShopBuilder",
                  },
                ],
              },
              [
                _vm._t("autocomplete-suggestions", function () {
                  return [
                    _c(
                      "div",
                      { staticClass: "autocomplete-suggestions" },
                      [
                        _vm.hasAutocompleteResults
                          ? [
                              _vm.autocompleteResult.item.length > 0
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "autocomplete-suggestions__top",
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "autocomplete-suggestions__suggestion autocomplete-suggestions__suggestion--item",
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "autocomplete-suggestions__suggestion-headline",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$translate(
                                                    "HoferAntikschmuck::Template.objects"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("search-suggestion-item", {
                                            attrs: {
                                              "show-images": true,
                                              "result-amount": 5,
                                              "suggestion-type": "item",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "autocomplete-suggestions__show-all",
                                          on: {
                                            click: function ($event) {
                                              return _vm.search()
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\t\t\t" +
                                              _vm._s(
                                                _vm.$translate(
                                                  "HoferAntikschmuck::Template.allResults"
                                                )
                                              ) +
                                              "\n\t\t\t\t\t\t\t\t\t\t"
                                          ),
                                          _c(
                                            "svg",
                                            {
                                              attrs: {
                                                width: "12",
                                                height: "12",
                                                stroke: "currentColor",
                                              },
                                            },
                                            [
                                              _c("use", {
                                                attrs: {
                                                  "xlink:href": "#arrow-right",
                                                },
                                              }),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.autocompleteResult.category.length > 0 ||
                              _vm.autocompleteResult.suggestion.length > 0
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "autocomplete-suggestions__bottom",
                                    },
                                    [
                                      _vm.autocompleteResult.category.length > 0
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "autocomplete-suggestions__suggestion autocomplete-suggestions__suggestion--category",
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "autocomplete-suggestions__suggestion-headline",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$translate(
                                                        "HoferAntikschmuck::Template.categories"
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("search-suggestion-item", {
                                                attrs: {
                                                  "show-images": false,
                                                  "result-amount": 5,
                                                  "suggestion-type": "category",
                                                },
                                              }),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.autocompleteResult.suggestion.length >
                                      0
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "autocomplete-suggestions__suggestion autocomplete-suggestions__suggestion--suggestion",
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "autocomplete-suggestions__suggestion-headline",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$translate(
                                                        "HoferAntikschmuck::Template.searchSuggestions"
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("search-suggestion-item", {
                                                attrs: {
                                                  "show-images": false,
                                                  "result-amount": 5,
                                                  "suggestion-type":
                                                    "suggestion",
                                                },
                                              }),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          : [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "autocomplete-suggestions__no-results",
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t\t" +
                                      _vm._s(
                                        _vm.$translate(
                                          "Ceres::Template.itemSearchSuggestionNoResults"
                                        )
                                      ) +
                                      "\n\t\t\t\t\t\t\t\t"
                                  ),
                                ]
                              ),
                            ],
                      ],
                      2
                    ),
                  ]
                }),
              ],
              2
            ),
          ],
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }